import type { ContratProDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { NaturesFichierProvider } from '@/features/domaine/types/opco'

export const NATURE_CPRO = 'NATURE_CPRO' as const
export const naturesFichiersCpro: NaturesFichierProvider<ContratProDTO> = {
  getNaturesFichiers: (_demande, typeContext) => {
    let obligatoires = ['Cerfa', 'Convention']
    let facultatifs = ['Autre']
    let facultatifsDefaut: string[] = []

    if (typeContext === TypesContextesAutorisesEnum.Prestataire) {
      facultatifs = [...obligatoires, ...facultatifs]
      facultatifsDefaut = [...obligatoires, ...facultatifsDefaut]
      obligatoires = []
    }

    return {
      obligatoires: obligatoires,
      facultatifs: facultatifs,
      facultatifsDefaut: facultatifsDefaut,
      /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
          {
              'Cerfa': 10,
              'Convention': 2
          }
      */
      nombreFichiersMaximum: {},
      nombreFichiersMinimum: {},
    }
  },
  key: NATURE_CPRO,
}
